<template>
    <div class="list--entry flex relative" @click="$router.push(`/overview/element/${element.id}`)">
        <div class="width--100 height--100 grid list--entry__grid3 font--s14">
            <div class="flex flex--column flex--center__hor pad--2 lineHeight--1">
                <div class="font--s1 color--grey">
                    Status
                </div>
                <div class="font--w700">
                    {{ element.healthy ? 'Mangelfrei' : 'Beschädigt' }}
                </div>
            </div>
            <div class="flex flex--column flex--center__hor pad--2 lineHeight--1">
                <div class="font--s1 color--grey">
                    Element
                </div>
                <div class="font--w700">
                    {{ element.element }}
                </div>
            </div>
            <div class="flex flex--column flex--center__hor pad--2 lineHeight--1">
                <div class="font--s1 color--grey">
                    Typ
                </div>
                <div class="font--w700">
                    {{ element.type }}
                </div>
            </div>
            <div class="flex flex--center">
                <ActionButton icon="pencil" accent="true"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ActionButton from "@/components/Buttons/ActionButton";
    export default {
        components: {ActionButton},
        props: {
            element: {
                type: Object,
                default: () => {},
            }
        }
    }
</script>

<style scoped>

</style>
